import React, { useContext } from "react";
import { TextField, InputLabel } from "@material-ui/core";

import { useStyles } from "./styles";
import { MatchContext } from "../../context";

export default function StockpileNameInput({ handleChange }): JSX.Element {
  const classes = useStyles();
  const { state } = useContext(MatchContext);

  return (
    <React.Fragment>
      <InputLabel id="stockpile-name-label">Stockpile</InputLabel>
      <div className={classes.container}>
        <TextField
          id="stockpile-name"
          value={state.stockpileName}
          type="text"
          className={classes.textFieldLeft}
          onChange={handleChange}
          disabled={state.showStockpileData}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
    </React.Fragment>
  );
}
